import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = ({ type = 'home' }) => {

  const siteUrl = 'https://shreejiambulance.in/'; // Update with your actual domain

  const getStructuredData = () => {
    const baseData = {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "Shreeji Ambulance",
      "description": "Trusted Ambulance & Patient Transport Services Since 2003. Available across India from Ahmedabad.",
      "url": siteUrl,
      "logo": `${siteUrl}Shreeji%20Ambulance%20-%20Finaize.svg`,
      "image": `${siteUrl}Shreeji%20Ambulance%20-%20Finaize.svg`,
      "telephone": ["+919825957225", "+919979049999"],
      "priceRange": "$$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "V.S hospital, Ellisbridge",
        "addressLocality": "Ahmedabad",
        "addressRegion": "Gujarat",
        "postalCode": "380006",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "23.0225",
        "longitude": "72.5714"
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "areaServed": {
        "@type": "Country",
        "name": "India"
      },
      "serviceType": [
        "Emergency Ambulance Service",
        "ICU Ambulance",
        "Patient Transfer",
        "Medical Escort Services",
        "Hospital Transfer",
        "Long Distance Patient Transport",
        "Mortuary Ambulance Service"
      ],
      "foundingDate": "2003",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "150"
      }
    };

    if (type === 'home') {
      return {
        ...baseData,
        "@type": ["MedicalBusiness", "LocalBusiness"],
        "potentialAction": {
          "@type": "ReserveAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": `${siteUrl}/contact`
          }
        }
      };
    }

    return baseData;
  };

  const structuredData = getStructuredData();

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData, null, 2)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
